import { isEmpty } from 'lodash-es';
import { array, object, string, number, date, mixed } from 'yup';

const locationSchema = array().of(
  object().shape({
    area: string().nullable(true),
    city: string().nullable(true),
    continent: string().nullable(true),
    continentCode: string().nullable(true),
    country: string().nullable(true),
    countryCode: string().nullable(true),
    lat: mixed()
      .nullable(true)
      .transform((value) => (!isEmpty(value) ? value : null)),
    lon: mixed()
      .nullable(true)
      .transform((value) => (!isEmpty(value) ? value : null)),
    placeId: string().nullable(true),
    point: string().nullable(true),
    state: string().nullable(true),
    stateCode: string().nullable(true),
    zipCode: string().nullable(true),
  })
);

const singleWsButtonGroup = object()
  .shape({
    index: number(),
    key: string(),
  })
  .required();

export const prowAndProSchema = object().shape({
  name: string().required('Please enter name'),
  email: string().email('Please enter email'),
  phone: string()
    .matches(
      /^$|^[+(]?\(?\(?\d{1,4}?[-.()\s]?\(?\d{1,3}?\)?[-.()\s]?\d{1,4}[-.()\s]?\d{1,4}[-.()\s]?\d{1,9}[)\d]$/,
      'Please enter valid phone number'
    )
    .required('Please enter phone number'),
  socialLinks: array().of(string()).required('Please enter social links'),
  dob: date().required('Please enter DOB').typeError('Date is required'),
  portfolio: string().nullable(true),
  currentLocation: locationSchema.required('Please enter candidate location'),
  candidateSkills: array()
    .of(
      object().shape({
        skill: string(),
        score: number(),
        yearsUsed: number(),
      })
    )
    .required('Please enter skills'),
  experience: array()
    .of(
      object().shape({
        title: string(),
        org: string(),
        periodStart: object().shape({
          year: number(),
          month: number(),
          day: number(),
        }),
        periodEnd: object().shape({
          year: number(),
          month: number(),
          day: number(),
        }),
      })
    )
    .required('Please enter experience'),
  education: array()
    .of(
      object().shape({
        org: string(),
        degree: string(),
        major: string(),
        periodStart: object().shape({
          year: number(),
          month: number(),
          day: number(),
        }),
        periodEnd: object().shape({
          year: number(),
          month: number(),
          day: number(),
        }),
      })
    )
    .required('Please enter education'),
  militaryService: array()
    .of(
      object().shape({
        title: string().nullable(true),
        org: string().nullable(true),
        periodStart: object().shape({
          year: number().nullable(true),
          month: number().nullable(true),
          day: number().nullable(true),
        }),
        periodEnd: object().shape({
          year: number().nullable(true),
          month: number().nullable(true),
          day: number().nullable(true),
        }),
      })
    )
    .nullable(true),
  language: string().required('Please select language'),
  ssnNumber: number().required('Please enter SSN number').typeError('Number is required'),
  availableFrom: date().required('Please enter available from').typeError('Date is required'),
  payRate: number().required('Please enter pay rate').typeError('Number is required'),
  isPreviousEmployee: singleWsButtonGroup,
  providedServiceThroughThirdParty: singleWsButtonGroup,
  subContractedWorker: singleWsButtonGroup,
  isH1B: singleWsButtonGroup,
  flsaClassification: string().required('Please select supplier FLSA classification'),
  supplierNotes: string().required('Please enter supplier notes'),
  summary: string().required('Please enter summary'),
});
